import PanToolIcon from '@mui/icons-material/PanTool';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import { grey, red } from '@mui/material/colors';
import SituacaoIdDescricaoBase from './SituacaoIdDescricaoBase';

/**
 * Enum para situações de impedimentos de magistrados no processo.
 *
 * @readonly
 * @constant
 * @enum {Object.<string, Object>}
 */
// prettier-ignore
export const SITUACAO_IMPEDIMENTOS_PROCESSO = {
    POSSIVEL_IMPEDIMENTO_NA_COMPOSICAO:       { id: 'POSSIVEL_IMPEDIMENTO_NA_COMPOSICAO',       descricao: 'Possível impedimento na composição do processo',       cor: red[900],  opacidade: 0.7, corFundo: 'transparent' },
    IMPEDIMENTO_DECLARADO_NA_COMPOSICAO:      { id: 'IMPEDIMENTO_DECLARADO_NA_COMPOSICAO',      descricao: 'Impedimento declarado na composição do processo',      cor: red[900],  opacidade: 0.7, corFundo: 'transparent' },
    POSSIVEL_IMPEDIMENTO_FORA_DA_COMPOSICAO:  { id: 'POSSIVEL_IMPEDIMENTO_FORA_DA_COMPOSICAO',  descricao: 'Possível impedimento fora da composição do processo',  cor: grey[700], opacidade: 0.7, corFundo: 'transparent' },
    IMPEDIMENTO_DECLARADO_FORA_DA_COMPOSICAO: { id: 'IMPEDIMENTO_DECLARADO_FORA_DA_COMPOSICAO', descricao: 'Impedimento declarado fora da composição do processo', cor: grey[700], opacidade: 0.7, corFundo: 'transparent' },
};

/**
 * @classdesc Facilita o acesso às propriedades e valores da enum de situações de impedimentos.
 * @readonly
 */
export default class SituacaoImpedimentosProcesso {
    static situacaoBase = new SituacaoIdDescricaoBase(SITUACAO_IMPEDIMENTOS_PROCESSO);
    static MSG_ERRO_IDENTIFICACAO_SITUACAO = 'Não foi possível identificar a situação do impedimento.';

    static getDescricao(id) {
        return SituacaoImpedimentosProcesso.situacaoBase.getDescricao(id);
    }

    static getCor(id) {
        return SituacaoImpedimentosProcesso.situacaoBase.getValorPropriedade(id, 'cor');
    }

    static getIcone(id, tamanhoIcone = '22px', cor = undefined) {
        let obj = SituacaoImpedimentosProcesso.situacaoBase.getObjectById(id);

        if (id.indexOf('DECLARADO') !== -1) {
            return (
                <PanToolIcon
                    style={{
                        width: tamanhoIcone,
                        height: tamanhoIcone,
                        color: cor ?? obj.cor,
                        fill: cor ?? obj.cor,
                        fillOpacity: obj.opacidade ? obj.opacidade : 1,
                        backgroundColor: obj.corFundo ? obj.corFundo : 'transparent'
                    }}
                />
            );
        }

        return (
            <ThumbDownIcon
                style={{
                    width: tamanhoIcone,
                    height: tamanhoIcone,
                    color: cor ?? obj.cor,
                    fill: cor ?? obj.cor,
                    fillOpacity: obj.opacidade ? obj.opacidade : 1,
                    backgroundColor: obj.corFundo ? obj.corFundo : 'transparent',
                    transform: 'scaleX(-1)'
                }}
            />
        );
    }
}
